/* src/modules/profile/api.js */

import gql from 'graphql-tag';
import { PROFILE_FRAGMENT } from '../auth/api';

export const CHANGE_PASSWORD_MUTATION = gql`
  mutation changePassword($old: String!, $new: String!) {
    changePassword(newPassword: $new, oldPassword: $old)
  }
`;

export const MODIFY_USER_MUTATION = gql`
  mutation modifyUser($userUpdateInput: UserUpdateInput) {
    modifyUser(input: $userUpdateInput) {
      _id
    }
  }
`;

export const UPDATE_ADMIN_NOTIF_PREF_MUTATION = gql`
  mutation updateAdminNotificationPreference($notificationPreferenceInput: [NotificationPreferenceInput]!) {
    updateAdminNotificationPreference(updateList: $notificationPreferenceInput) {
      ...ProfileFragment
    }
  }
  ${PROFILE_FRAGMENT}
`;



// WEBPACK FOOTER //
// ./src/modules/profile/api.js